import Flickity from 'flickity';
import { flickityArrowShape } from '../constants';

let defaults = {
	arrowShape: flickityArrowShape,
};

export function createFlickity(element, options = {}) {
	let config = { ...defaults, ...options };

	let flkty = new Flickity(element, config);

	update(flkty);

	function update(instance) {
		let enabled = instance.slideableWidth > instance.size.width;

		instance.options.draggable = enabled;

		if (enabled) {
			instance.prevButton.element.removeAttribute('hidden');
			instance.nextButton.element.removeAttribute('hidden');
		} else {
			instance.prevButton.element.setAttribute('hidden', '');
			instance.nextButton.element.setAttribute('hidden', '');
		}
		instance.updateDraggable();
		positionArrows(instance);
	}

	function positionArrows(instance) {
		let element = instance.element;
		let images = Array.from(element.querySelectorAll('.js-flickity-media'));

		if (images.length === 0) {
			return;
		}

		let imageHeights = images.map(image => image.clientHeight);
		let maxImageHeight = Math.max(...imageHeights);

		instance.prevButton.element.style.top = `${maxImageHeight / 2}px`;
		instance.nextButton.element.style.top = `${maxImageHeight / 2}px`;
	}

	flkty.on('resize', () => update(flkty));

	return flkty;
}
